import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Params = Api.Sales.ContractRefund.SetStatus.IParams;
type Request = Api.Sales.ContractRefund.SetStatus.IRequest;
type Response = Api.Sales.ContractRefund.SetStatus.IResponse;
type Headers = Api.Sales.ContractRefund.SetStatus.IHeaders;
const url = '/api/Sales/ContractRefund/SetStatus/:id';
export default async function contractRefundSetStatusApi({ id, ...body }: Params & Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.put,
    url: createPathFromRoute(url, { id }, null),
    body,
    headers: getDefaultHeaders(),
  });
}
